import React, { useState } from 'react';
import './CardSelection.css';
import Button from '../ui/Button';
import cards from '../../data/cards';

const CardSelection = ({ selectedCards, setSelectedCards, requiredCount }) => {
  const [showCardPool, setShowCardPool] = useState(false);
  const [filterTeam, setFilterTeam] = useState('all');
  
  // Filter cards by team if a filter is selected
  const filteredCards = filterTeam === 'all' 
    ? cards 
    : cards.filter(card => card.team === filterTeam);

  // Toggle card selection
  const toggleCardSelection = (cardId) => {
    if (selectedCards.includes(cardId)) {
      // Remove card from selection
      setSelectedCards(prev => prev.filter(id => id !== cardId));
    } else if (selectedCards.length < requiredCount) {
      // Add card to selection
      setSelectedCards(prev => [...prev, cardId]);
    }
  };

  return (
    <div className="card-selection">
      <div className="card-selection__header">
        <h3 className="card-selection__title">Kartları Seç</h3>
        <span className="card-selection__counter">
          {selectedCards.length}/{requiredCount}
        </span>
      </div>
      
      {selectedCards.length > 0 && (
        <div className="card-selection__selected">
          <h4>Seçilen Kartlar:</h4>
          <div className="card-selection__chips">
            {selectedCards.map(cardId => {
              const card = cards.find(c => c.id === cardId);
              return (
                <div 
                  key={cardId} 
                  className={`card-selection__chip card-selection__chip--${card.team}`}
                  onClick={() => toggleCardSelection(cardId)}
                >
                  {card.name}
                  <span className="card-selection__chip-remove">×</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
      
      {!showCardPool ? (
        <div className="card-selection__actions">
          <Button 
            onClick={() => setShowCardPool(true)} 
            variant="secondary" 
            fullWidth={true}
          >
            Kart Havuzunu Göster
          </Button>
          
          {selectedCards.length === requiredCount && (
            <div className="card-selection__success-message">
              Yeterli kart seçildi! Artık oyunu başlatabilirsiniz.
            </div>
          )}
          
          {selectedCards.length > 0 && selectedCards.length < requiredCount && (
            <div className="card-selection__info-message">
              Oyunu başlatmak için {requiredCount - selectedCards.length} kart daha seçmelisiniz.
            </div>
          )}
          
          {selectedCards.length === 0 && (
            <div className="card-selection__info-message">
              Hiç kart seçilmedi. Lütfen {requiredCount} kart seçin.
            </div>
          )}
        </div>
      ) : (
        <>
          <div className="card-selection__filters">
            <button 
              className={`card-selection__filter ${filterTeam === 'all' ? 'card-selection__filter--active' : ''}`}
              onClick={() => setFilterTeam('all')}
            >
              Tümü
            </button>
            <button 
              className={`card-selection__filter card-selection__filter--villager ${filterTeam === 'villager' ? 'card-selection__filter--active' : ''}`}
              onClick={() => setFilterTeam('villager')}
            >
              Köylü
            </button>
            <button 
              className={`card-selection__filter card-selection__filter--werewolf ${filterTeam === 'werewolf' ? 'card-selection__filter--active' : ''}`}
              onClick={() => setFilterTeam('werewolf')}
            >
              Kurt Adam
            </button>
            <button 
              className={`card-selection__filter card-selection__filter--tanner ${filterTeam === 'tanner' ? 'card-selection__filter--active' : ''}`}
              onClick={() => setFilterTeam('tanner')}
            >
              Düzenbaz
            </button>
          </div>
          
          <div className="card-selection__pool">
            {filteredCards.map(card => (
              <div 
                key={card.id} 
                className={`card-selection__card ${selectedCards.includes(card.id) ? 'card-selection__card--selected' : ''}`}
                onClick={() => toggleCardSelection(card.id)}
              >
                <div className="card-selection__card-header">
                  <h4 className="card-selection__card-name">{card.name}</h4>
                  <span className={`card-selection__card-team card-selection__card-team--${card.team}`}>
                    {card.team === 'werewolf' && 'Kurt Adam'}
                    {card.team === 'villager' && 'Köylü'}
                    {card.team === 'tanner' && 'Düzenbaz'}
                  </span>
                </div>
                <div className="card-selection__card-description">
                  {card.description}
                </div>
                <div className="card-selection__card-status">
                  {selectedCards.includes(card.id) ? (
                    <span className="card-selection__card-selected-mark">✓</span>
                  ) : (
                    selectedCards.length < requiredCount && (
                      <span className="card-selection__card-select-prompt">Seç</span>
                    )
                  )}
                </div>
              </div>
            ))}
          </div>
          
          <Button
            onClick={() => setShowCardPool(false)}
            variant="secondary"
            fullWidth={true}
          >
            Geri Dön
          </Button>
        </>
      )}
    </div>
  );
};

export default CardSelection;
